const TRACK_BUGS_URL = 'https://iph0vhcscg.execute-api.us-east-2.amazonaws.com/default/trackBugs';

export const trackBug = async (url: string) => {
  const path = new URL(url).pathname;
  const parts = path.split('/');
  const apiName = parts[parts.length - 1];

  const config = {
    queryParams: {
      bug: apiName,
    },
  };
  callApi(TRACK_BUGS_URL, config, true);
};

export const callApi = async (
  url: string,
  config: any,
  auth: boolean,
  gzip: boolean = false,
  key: string = '',
  method: string = 'GET',
  returnErrorJson: boolean = false,
  signal?: AbortSignal,
  returnErrorStatusCode?: boolean,
  returnHeaders?: boolean
) => {
  let body;
  let queryParams = '';
  if (config) {
    body = config.body;

    if (config.queryParams) {
      const paramsKeys = Object.keys(config.queryParams);

      queryParams = paramsKeys
        .map((key, index) => {
          const prefix = index === 0 ? '?' : '';

          return `${prefix}${key}=${config.queryParams[key]}`;
        })
        .join('&');
    }
  }
  let headers = {
    ...config,
    body: JSON.stringify(body),
  };

  if (auth) {
    headers = {
      ...config,
      headers: {
        authorization: `Bearer ${localStorage.getItem('auth-token')}`,
      },
      mode: 'cors',
      body: JSON.stringify(body),
    };
  }

  if (gzip) {
    headers = {
      ...headers,
      headers: {
        ...headers['headers'],
        //'accept-encoding': 'gzip'
      },
      gzip: true,
    };
  }

  if (key) {
    headers = {
      ...headers,
      headers: {
        ...headers['headers'],
        'x-api-key': key,
      },
    };
  }
  // console.log('headers ', headers)

  try {
    let response;
    if (method === 'POST' || method === 'PUT' || method === 'DELETE') {
      const requestData: any = {
        method: method,
        headers: auth
          ? {
              authorization: `Bearer ${localStorage.getItem('auth-token')}`,
            }
          : {},
      };

      if (body) {
        requestData['body'] = JSON.stringify(body);
      }

      if (signal) {
        requestData['signal'] = signal;
      }

      response = await fetch(queryParams ? `${url}${queryParams}` : url, requestData);
    } else {
      const fetchHeaders = signal ? { ...headers, signal } : headers;
      response = await fetch(`${url}${queryParams}`, fetchHeaders);
    }
    /*
      fetch can either
      - return response
        - success: status_code 200
        - failed: status_code: 4xx, 5xx
      - throw an error
    */
    const json = await response.json();
    if (response.ok) {
      return json;
    } else {
      return returnErrorJson ? {...json, status: response.status} : `${response.status}: ${response.statusText || 'Error'}`;
    }
  } catch (error) {
    // Don't track abort errors as bugs or track bugs url calls
    const isAbort =
      (error instanceof Error && error.name === 'AbortError') ||
      (typeof DOMException !== 'undefined' &&
        error instanceof DOMException &&
        error.name === 'AbortError');
    if (isAbort || url === TRACK_BUGS_URL) {
      throw error;
    }
    trackBug(url);
    return returnErrorJson ? { error: error, status: 400 } : error;
  }
};
